import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import * as CappieReporterActions from './cappie-reporter.actions';
import { CappieReporterTypes } from '@mode/shared/contract-common';
import { dispatchEvent } from '@mode/shared/util-js';

@Injectable()
export class CappieReporterEffects {
  renderingProgressReported$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CappieReporterActions.progressReporting),
        tap((action) =>
          dispatchEvent<CustomEvent<CappieReporterTypes.ProgressData>>(window, 'PROGRESS-REPORTING', {
            detail: action.eventData,
          })
        )
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions) {}
}
